<template>
  <div class="layout-column">

    <!-- Abstand Tumorunterrand zur Anokutanlinie -->

    <div class="flex-gt-sm-100 flex-100 px-2 layout-row">
      <validation-provider tag="div"
                           class="flex-gt-sm-50 flex-100"
                           :name="path + '.rektum_abstand_anokutanlinie.abstand'"
                           :ref="path + '.rektum_abstand_anokutanlinie.abstand'"
                           :rules="{integer: true,between:[1,999]}"
                           v-slot="{ errors }">
        <lx-numberfield :disabled="model.rektum_abstand_anokutanlinie.u==='U' || isDisabled"
                        :dense="denseFields"
                        v-model="model.rektum_abstand_anokutanlinie.abstand"
                        :label="$t('FORMS_DIVERSE.MODULE_KOLO_DISTANCE_TO_ANOKUTAN_LINE')"
                        separator=","
                        suffix="mm"
                        :maxLength="3"
                        @input="refactorEmptyIntValue(model.rektum_abstand_anokutanlinie.abstand, 'rektum_abstand_anokutanlinie', 'abstand')"
                        :hint="$t('FORMS_DIVERSE.MODULE_KOLO_DISTANCE_HINT')"
                        persistent-hint
                        :error-messages="errors[0]"
        ></lx-numberfield>
      </validation-provider>

      <div class="pl-5" :class="denseFields ? 'mt-n1' : 'mt-0'">
        <validation-provider tag="div"
                             class="flex-gt-sm-50 flex-100"
                             :name="path + '.rektum_abstand_anokutanlinie.u'"
                             :ref="path + '.rektum_abstand_anokutanlinie.u'"
                             v-slot="{ errors }">
          <v-checkbox :label="$t('FORMS_DIVERSE.UNKNOWN')"
                      :dark="compColor.isInDarkMode"
                      :color="compColor.primeColor"
                      v-model="model.rektum_abstand_anokutanlinie.u"
                      value="U"
                      class="mt-0 py-0 mb-2"
                      :error-messages="errors[0]"
                      @change="model.rektum_abstand_anokutanlinie.abstand=null"
                      :disabled="isDisabled">
          </v-checkbox>
        </validation-provider>
      </div>
    </div>

    <!-- Minimaler Abstand vom aboralen Resektionsrand -->

    <div class="flex-gt-sm-100 flex-100 px-2 layout-row">
      <validation-provider tag="div"
                           class="flex-gt-sm-50 flex-100"
                           :name="path + '.rektum_abstand_aboraler_resektionsrand.abstand'"
                           :ref="path + '.rektum_abstand_aboraler_resektionsrand.abstand'"
                           :rules="{integer: true,between:[1,999]}"
                           v-slot="{ errors }">
        <lx-numberfield :disabled="model.rektum_abstand_aboraler_resektionsrand.u==='U' || isDisabled"
                        :dense="denseFields"
                        v-model="model.rektum_abstand_aboraler_resektionsrand.abstand"
                        :label="$t('FORMS_DIVERSE.MODULE_KOLO_DISTANCE_TO_RESEKTION_BORDER')"
                        separator=","
                        suffix="mm"
                        :maxLength="3"
                        @input="refactorEmptyIntValue(model.rektum_abstand_aboraler_resektionsrand.abstand, 'rektum_abstand_aboraler_resektionsrand', 'abstand')"
                        :hint="$t('FORMS_DIVERSE.MODULE_KOLO_DISTANCE_HINT')"
                        persistent-hint
                        :error-messages="errors[0]"
        ></lx-numberfield>
      </validation-provider>

      <div class="pl-5" :class="denseFields ? 'mt-n1' : 'mt-0'">
        <validation-provider tag="div"
                             class="flex-gt-sm-50 flex-100"
                             :name="path + '.rektum_abstand_aboraler_resektionsrand.u'"
                             :ref="path + '.rektum_abstand_aboraler_resektionsrand.u'"
                             v-slot="{ errors }">
          <v-checkbox :label="$t('FORMS_DIVERSE.UNKNOWN')"
                      :dark="compColor.isInDarkMode"
                      :color="compColor.primeColor"
                      v-model="model.rektum_abstand_aboraler_resektionsrand.u"
                      value="U"
                      class="mt-0 py-0 mb-2"
                      :error-messages="errors[0]"
                      @change="model.rektum_abstand_aboraler_resektionsrand.abstand=null"
                      :disabled="isDisabled">
          </v-checkbox>
        </validation-provider>
      </div>
    </div>

    <!-- Abstand zur circumferentiellen Resektionsebene -->

    <div class="flex-gt-sm-100 flex-100 px-2 layout-row">
      <validation-provider tag="div"
                           class="flex-gt-sm-50 flex-100"
                           :name="path + '.rektum_abstand_circ_resektionsebene.abstand'"
                           :ref="path + '.rektum_abstand_circ_resektionsebene.abstand'"
                           :rules="{integer: true,between:[1,999]}"
                           v-slot="{ errors }">
        <lx-numberfield :disabled="model.rektum_abstand_circ_resektionsebene.u==='U' || isDisabled"
                        :dense="denseFields"
                        v-model="model.rektum_abstand_circ_resektionsebene.abstand"
                        :label="$t('FORMS_DIVERSE.MODULE_KOLO_DISTANCE_TO_RESEKTION_LEVEL')"
                        separator=","
                        suffix="mm"
                        :maxLength="3"
                        @input="refactorEmptyIntValue(model.rektum_abstand_circ_resektionsebene.abstand, 'rektum_abstand_circ_resektionsebene', 'abstand')"
                        :hint="$t('FORMS_DIVERSE.MODULE_KOLO_DISTANCE_HINT')"
                        persistent-hint
                        :error-messages="errors[0]"
        ></lx-numberfield>
      </validation-provider>

      <div class="pl-5" :class="denseFields ? 'mt-n1' : 'mt-0'">
        <validation-provider tag="div"
                             class="flex-gt-sm-50 flex-100"
                             :name="path + '.rektum_abstand_circ_resektionsebene.u'"
                             :ref="path + '.rektum_abstand_circ_resektionsebene.u'"
                             v-slot="{ errors }">
          <v-checkbox :label="$t('FORMS_DIVERSE.UNKNOWN')"
                      :dark="compColor.isInDarkMode"
                      :color="compColor.primeColor"
                      v-model="model.rektum_abstand_circ_resektionsebene.u"
                      value="U"
                      class="mt-0 py-0"
                      :error-messages="errors[0]"
                      @change="model.rektum_abstand_circ_resektionsebene.abstand=null"
                      :disabled="isDisabled">
          </v-checkbox>
        </validation-provider>
      </div>
    </div>

    <!-- Qualität des TME-Präparates -->

    <div class="flex-100 px-2 mb-6">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_KOLO_QUALITY_OF_TME_PREPARATION')"
                        :disabled="isDisabled">
        <validation-provider tag="div"
                             :name="path + '.rektum_qualitaet_tme'"
                             :ref="path + '.rektum_qualitaet_tme'"
                             rules=""
                             class="flex layout-row"
                             v-slot="{ errors }">
          <div class="layout-column px-4 pb-3 pt-2 flex">
            <v-radio-group :dense="denseFields" v-model="model.rektum_qualitaet_tme" hide-details :error-messages="errors[0]" class="ma-0 pa-0" style="flex:unset;margin-top: 10px;">
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_QUALITY_OF_TME_PREPARATION_RADIO_BUTTONS.GOOD')"
                       value="1" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_QUALITY_OF_TME_PREPARATION_RADIO_BUTTONS.MODERATE')"
                       value="2" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_QUALITY_OF_TME_PREPARATION_RADIO_BUTTONS.BAD')"
                       value="3" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_QUALITY_OF_TME_PREPARATION_RADIO_BUTTONS.PME_EXECUTED')"
                       value="P" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_QUALITY_OF_TME_PREPARATION_RADIO_BUTTONS.LOCALE_EXCISION_EXECUTED')"
                       value="L" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_QUALITY_OF_TME_PREPARATION_RADIO_BUTTONS.OTHER_OP_EXECUTED')"
                       value="A" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_QUALITY_OF_TME_PREPARATION_RADIO_BUTTONS.UNKNOWN')"
                       value="U" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-btn :color="compColor.primeColor"
                     :dark="compColor.isInDarkMode"
                     depressed
                     text
                     width="auto"
                     class="white--text text-none layout-row layout-align-start-center ml-n2 px-2"
                     :class="denseFields ? 'pl-3' : ''"
                     @click="resetRadioButtons('rektum_qualitaet_tme')"
                     v-show="model.rektum_qualitaet_tme && !isDisabled"
                     :disabled="!model.rektum_qualitaet_tme || isDisabled"
                     :title="$t('buttons.deleteSelection.title')">
                <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass" size="24">mdi-arrow-up-bold</v-icon>
                <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
              </v-btn>
            </v-radio-group>
          </div>
        </validation-provider>
      </fake-input-frame>
    </div>

    <!-- Abstand zur mesorektalen Faszie -->

    <div class="flex-gt-sm-100 flex-100 px-2 mb-6">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_KOLO_DISTANCE_TO_FASZIE')"
                        :disabled="isDisabled">
        <div class="flex-gt-sm-50 flex-100 px-3 pt-3">
          <validation-provider tag="div"
                               :name="path + '.rektum_mrt_duennschicht_angabemesorektale_faszie.abstand'"
                               :ref="path + '.rektum_mrt_duennschicht_angabemesorektale_faszie.abstand'"
                               :rules="{integer: true,between:[0,99]}"
                               v-slot="{ errors }">
            <lx-numberfield :disabled="isDisabled"
                            :dense="denseFields"
                            v-model="model.rektum_mrt_duennschicht_angabemesorektale_faszie.abstand"
                            separator=","
                            suffix="mm"
                            :maxLength="2"
                            class="flex-50 mr-10"
                            @input="refactorEmptyValue(model.rektum_mrt_duennschicht_angabemesorektale_faszie.abstand)"
                            :hint="$t('FORMS_DIVERSE.MODULE_KOLO_DISTANCE_HINT_TO_99')"
                            persistent-hint
                            :error-messages="errors[0]"
            ></lx-numberfield>
          </validation-provider>
        </div>

        <div class="flex-gt-sm-100 ml-3 mb-4" :class="compColor.primeClass">{{ $t('OR') }}</div>

        <div class="flex-100 px-2 mb-3 layout-row">
          <validation-provider tag="div"
                               :name="path + '.rektum_mrt_duennschicht_angabemesorektale_faszie.dnu'"
                               :ref="path + '.rektum_mrt_duennschicht_angabemesorektale_faszie.dnu'"
                               rules=""
                               v-slot="{ errors }">
            <v-radio-group :dense="denseFields" v-model="model.rektum_mrt_duennschicht_angabemesorektale_faszie.dnu"
                           hide-details
                           row
                           :error-messages="errors[0]"
                           class="pa-0"
                           :class="{'mt-2': denseFields, 'mt-3': !denseFields}"
                           style="flex:unset;">
              <v-radio :label="$t('FORMS_DIVERSE.RADIO_GROUP_KOLO_DNU.D')"
                       @click="model.rektum_mrt_duennschicht_angabemesorektale_faszie.abstand=undefined"
                       value="D" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.RADIO_GROUP_KOLO_DNU.N')"
                       @click="model.rektum_mrt_duennschicht_angabemesorektale_faszie.abstand=undefined"
                       value="N" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.RADIO_GROUP_KOLO_DNU.U')"
                       @click="model.rektum_mrt_duennschicht_angabemesorektale_faszie.abstand=undefined"
                       value="U" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
            </v-radio-group>
          </validation-provider>

          <div>
            <v-btn :color="compColor.primeColor"
                   :dark="compColor.isInDarkMode"
                   depressed
                   text
                   width="auto"
                   class="white--text text-none layout-row layout-align-start-center ml-n2 px-2"
                   :class="{'mt-0': denseFields, 'mt-1': !denseFields}"
                   @click="resetRadioButtons('dnu', 'rektum_mrt_duennschicht_angabemesorektale_faszie')"
                   v-show="model.rektum_mrt_duennschicht_angabemesorektale_faszie.dnu && !isDisabled"
                   :disabled="!model.rektum_mrt_duennschicht_angabemesorektale_faszie.dnu || isDisabled"
                   :title="$t('buttons.deleteSelection.title')">
              <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass" size="24">mdi-arrow-left-bold</v-icon>
              <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
            </v-btn>
          </div>
        </div>
      </fake-input-frame>
    </div>

    <!--Art des Eingriffs -->

    <div class="flex-100 px-2 mb-6">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_KOLO_KIND_OF_INTERVENTION')"
                        :disabled="isDisabled">
        <validation-provider tag="div"
                             :name="path + '.art_eingriff'"
                             :ref="path + '.art_eingriff'"
                             rules=""
                             class="flex layout-row"
                             v-slot="{ errors }">
          <div class="layout-column px-4 py-2 flex">
            <v-radio-group :dense="denseFields" v-model="model.art_eingriff" hide-details :error-messages="errors[0]" class="ma-0 pa-0" style="flex:unset;margin-top: 10px;">
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_KIND_OF_INTERVENTION_RADIO_BUTTONS.ELECTIVE')"
                       value="E" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_KIND_OF_INTERVENTION_RADIO_BUTTONS.EMERGENCY')"
                       value="N" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_KIND_OF_INTERVENTION_RADIO_BUTTONS.UNKNOWN')"
                       value="U" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-btn :color="compColor.primeColor"
                     :dark="compColor.isInDarkMode"
                     depressed
                     text
                     width="auto"
                     class="white--text text-none layout-row layout-align-start-center ml-n2 px-2"
                     :class="denseFields ? 'pl-3' : ''"
                     @click="resetRadioButtons('art_eingriff')"
                     v-show="model.art_eingriff && !isDisabled"
                     :disabled="!model.art_eingriff || isDisabled"
                     :title="$t('buttons.deleteSelection.title')">
                <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass" size="24">mdi-arrow-up-bold</v-icon>
                <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
              </v-btn>
            </v-radio-group>
          </div>
        </validation-provider>
      </fake-input-frame>
    </div>

    <!-- Präop Anzeichnung Stomaposition -->

    <div class="flex-100 px-2 mb-6">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_KOLO_PRAEOP_MARKING_STOMA')"
                        :disabled="isDisabled">
        <validation-provider tag="div"
                             :name="path + '.rektum_anzeichnung_stomaposition'"
                             :ref="path + '.rektum_anzeichnung_stomaposition'"
                             rules=""
                             class="flex layout-row"
                             v-slot="{ errors }">
          <div class="layout-column px-4 py-2 flex">
            <v-radio-group :dense="denseFields" v-model="model.rektum_anzeichnung_stomaposition" hide-details :error-messages="errors[0]" class="ma-0 pa-0" style="flex:unset;margin-top: 10px;">
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_PRAEOP_MARKING_STOMA_RADIO_BUTTONS.MARKING')"
                       value="D" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_PRAEOP_MARKING_STOMA_RADIO_BUTTONS.NO_MARKING')"
                       value="N" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_PRAEOP_MARKING_STOMA_RADIO_BUTTONS.NO_STOMA')"
                       value="K" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_PRAEOP_MARKING_STOMA_RADIO_BUTTONS.STOMA_UNKNOWN_MARKING')"
                       value="S" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_PRAEOP_MARKING_STOMA_RADIO_BUTTONS.UNKNOWN')"
                       value="U" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>

              <!-- Reset value of rektum_anzeichnung_stomaposition via button  -->

              <v-btn :color="compColor.primeColor"
                     :dark="compColor.isInDarkMode"
                     depressed
                     text
                     width="auto"
                     class="white--text text-none layout-row layout-align-start-center ml-n2 px-2"
                     :class="denseFields ? 'pl-3' : ''"
                     @click="resetRadioButtons('rektum_anzeichnung_stomaposition')"
                     v-show="model.rektum_anzeichnung_stomaposition && !isDisabled"
                     :disabled="!model.rektum_anzeichnung_stomaposition || isDisabled"
                     :title="$t('buttons.deleteSelection.title')">
                <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass" size="24">mdi-arrow-up-bold</v-icon>
                <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
              </v-btn>
            </v-radio-group>
          </div>
        </validation-provider>
      </fake-input-frame>
    </div>

    <!-- Anastomoseninsuffizienz -->

    <div class="flex-100 px-2 mb-6">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_KOLO_ANA_INSUFFICIENCY')"
                        :disabled="isDisabled">
        <validation-provider tag="div"
                             :name="path + '.grad_rektum_anastomoseninsuffizienz'"
                             :ref="path + '.grad_rektum_anastomoseninsuffizienz'"
                             rules=""
                             class="flex layout-row"
                             v-slot="{ errors }">
          <div class="layout-column px-4 py-2 flex">
            <v-radio-group :dense="denseFields" v-model="model.grad_rektum_anastomoseninsuffizienz" hide-details :error-messages="errors[0]" class="ma-0 pa-0" style="flex:unset;margin-top: 10px;">
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_ANA_INSUFFICIENCY_RADIO_BUTTONS.GRADE_A')"
                       value="K" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_ANA_INSUFFICIENCY_RADIO_BUTTONS.GRADE_B')"
                       value="B" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_ANA_INSUFFICIENCY_RADIO_BUTTONS.GRADE_C')"
                       value="C" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_ANA_INSUFFICIENCY_RADIO_BUTTONS.UNKNOWN')"
                       value="U" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>

              <!-- Reset value of grad_rektum_anastomoseninsuffizienz via button  -->

              <v-btn :color="compColor.primeColor"
                     :dark="compColor.isInDarkMode"
                     depressed
                     text
                     width="auto"
                     class="white--text text-none layout-row layout-align-start-center ml-n2 px-2"
                     :class="denseFields ? 'pl-3' : ''"
                     @click="resetRadioButtons('grad_rektum_anastomoseninsuffizienz')"
                     v-show="model.grad_rektum_anastomoseninsuffizienz && !isDisabled"
                     :disabled="!model.grad_rektum_anastomoseninsuffizienz || isDisabled"
                     :title="$t('buttons.deleteSelection.title')">
                <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass" size="24">mdi-arrow-up-bold</v-icon>
                <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
              </v-btn>
            </v-radio-group>
          </div>
        </validation-provider>
      </fake-input-frame>
    </div>

    <!--asa -->

    <div class="flex-100 px-2 mb-6">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_KOLO_ASA')"
                        :disabled="isDisabled">
        <validation-provider tag="div"
                             :name="path + '.asa'"
                             :ref="path + '.asa'"
                             rules=""
                             class="flex layout-row"
                             v-slot="{ errors }">
          <div class="layout-column px-4 py-2 flex">
            <v-radio-group :dense="denseFields" v-model="model.asa" hide-details :error-messages="errors[0]" class="ma-0 pa-0" style="flex:unset;margin-top: 10px;">
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_ASA_RADIO_BUTTONS.NORMAL')"
                       value="1" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_ASA_RADIO_BUTTONS.LIGHT')"
                       value="2" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_ASA_RADIO_BUTTONS.HEAVY')"
                       value="3" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_ASA_RADIO_BUTTONS.INACTIVE')"
                       value="4" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_ASA_RADIO_BUTTONS.NORIBUNDE')"
                       value="5" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>

              <!-- Reset value of asa via button  -->

              <v-btn :color="compColor.primeColor"
                     :dark="compColor.isInDarkMode"
                     depressed
                     text
                     width="auto"
                     class="white--text text-none layout-row layout-align-start-center ml-n2 px-2"
                     :class="denseFields ? 'pl-3' : ''"
                     @click="resetRadioButtons('asa')"
                     v-show="model.asa && !isDisabled"
                     :disabled="!model.asa || isDisabled"
                     :title="$t('buttons.deleteSelection.title')">
                <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass" size="24">mdi-arrow-up-bold</v-icon>
                <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
              </v-btn>
            </v-radio-group>
          </div>
        </validation-provider>
      </fake-input-frame>
    </div>

    <!--ras-Mutation -->

    <div class="flex-100 px-2 mb-6">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_KOLO_RAS_MUTATION')"
                        :disabled="isDisabled">
        <validation-provider tag="div"
                             :name="path + '.ras_mutation'"
                             :ref="path + '.ras_mutation'"
                             rules=""
                             class="flex layout-row"
                             v-slot="{ errors }">
          <div class="layout-column px-4 py-2 flex">
            <v-radio-group :dense="denseFields" v-model="model.ras_mutation" hide-details :error-messages="errors[0]" class="ma-0 pa-0" style="flex:unset;margin-top: 10px;">
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_RAS_MUTATION_RADIO_BUTTONS.WILD')"
                       value="W" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_RAS_MUTATION_RADIO_BUTTONS.MUTATION')"
                       value="M" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_RAS_MUTATION_RADIO_BUTTONS.UNKNOWN')"
                       value="U" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_KOLO_RAS_MUTATION_RADIO_BUTTONS.NOT_EXAMINED')"
                       value="N" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>

              <!-- Reset value of ras_mutation via button  -->

              <v-btn :color="compColor.primeColor"
                     :dark="compColor.isInDarkMode"
                     depressed
                     text
                     width="auto"
                     class="white--text text-none layout-row layout-align-start-center ml-n2 px-2"
                     :class="denseFields ? 'pl-3' : ''"
                     @click="resetRadioButtons('ras_mutation')"
                     v-show="model.ras_mutation && !isDisabled"
                     :disabled="!model.ras_mutation || isDisabled"
                     :title="$t('buttons.deleteSelection.title')">
                <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass" size="24">mdi-arrow-up-bold</v-icon>
                <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
              </v-btn>
            </v-radio-group>
          </div>
        </validation-provider>
      </fake-input-frame>
    </div>
  </div>
</template>

<script>
import utils from '../../../common/utils'

export default {
  name: "ModulKolo",
  mixins: [utils],
  props: {
    value: {
      type: Object,
      default: () => ({
        rektum_abstand_anokutanlinie: {},
        rektum_abstand_aboraler_resektionsrand: {},
        rektum_abstand_circ_resektionsebene: {},
        rektum_mrt_duennschicht_angabemesorektale_faszie: {}
      })
    },
    path: {
      type: String
    },
    base: {
      type: Object
    },
    isDisabled: {
      type: Boolean
    },
    validationRef: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      model: {
        rektum_abstand_anokutanlinie: {},
        rektum_abstand_aboraler_resektionsrand: {},
        rektum_abstand_circ_resektionsebene: {},
        rektum_mrt_duennschicht_angabemesorektale_faszie: {}
      }
    }
  },
  methods: {
    /**
     * Reset selected radio-button and trigger dirty flag of validator for save
     */
    resetRadioButtons (field, path) {
      if (path) {
        this.$set(this.model[path], field, null)
        field = path + '.' + field
      } else {
        this.$set(this.model, field, null)
      }

      this.validationRef.fields[this.path + '.' + field].changed = true
    },

    /**
     * Refactor integer of rektum_mrt_duennschicht_angabemesorektale_faszie and delete value of their radio buttons
     */
    refactorEmptyValue (value) {
      if (value) {
        // delete value of radio buttons if integer exists
        this.resetRadioButtons('dnu', 'rektum_mrt_duennschicht_angabemesorektale_faszie')
      }

      // refactor integer if empty
      this.refactorEmptyIntValue(this.model.rektum_mrt_duennschicht_angabemesorektale_faszie.abstand, 'rektum_mrt_duennschicht_angabemesorektale_faszie', 'abstand')
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
        }
      },
      immediate: true
    },
    'base.primaertumor_icd_code': {
      // reset module if already existing icd10 code has been changed
      handler: function (newValue, oldValue) {
        if (newValue && oldValue && newValue !== oldValue && !this.isDisabled) {
          this.model = {
            rektum_abstand_anokutanlinie: {},
            rektum_abstand_aboraler_resektionsrand: {},
            rektum_abstand_circ_resektionsebene: {},
            rektum_mrt_duennschicht_angabemesorektale_faszie: {}
          }
        }
      },
      immediate: true
    }
  }
}
</script>
